interface DateRangeFilterProps {
  startDate: string;
  endDate: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  minDate: string;
  maxDate: string;
}

export default function DateRangeFilter({ startDate, endDate, onChange, minDate, maxDate }: DateRangeFilterProps) {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-zinc-700 dark:text-zinc-300">
        Date Range
      </label>
      <div className="flex gap-2">
        <div className="w-1/2">
          <label className="block text-xs text-zinc-500 dark:text-zinc-400 mb-1">From</label>
          <input
            type="date"
            name="time_period_start"
            value={startDate}
            onChange={onChange}
            min={minDate}
            max={maxDate}
            className="block w-full px-3 py-2 text-sm rounded-lg border border-zinc-300 bg-white text-zinc-900 placeholder:text-zinc-400 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
          />
        </div>
        <div className="w-1/2">
          <label className="block text-xs text-zinc-500 dark:text-zinc-400 mb-1">To</label>
          <input
            type="date"
            name="time_period_end"
            value={endDate}
            onChange={onChange}
            min={minDate}
            max={maxDate}
            className="block w-full px-3 py-2 text-sm rounded-lg border border-zinc-300 bg-white text-zinc-900 placeholder:text-zinc-400 dark:border-zinc-700 dark:bg-zinc-900 dark:text-white focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500/20"
          />
        </div>
      </div>
    </div>
  );
} 